import { FaCheck } from "react-icons/fa";
import { SectionTitle } from "components/sectionTitle";
import rightThumb from "assets/images/homeV2/Platform_Chain.png";
import IntegrationStyleWrapper from "./Integration.style";
import { useTranslation } from "react-i18next";

const Integration = () => {
  const { t } = useTranslation();
  return (
    <IntegrationStyleWrapper>
      <div className="container">
        <div className="row">
          <div className="col-md-6">
            <div className="integration_left">
              <img src={rightThumb} alt="integration thumb " />
            </div>
          </div>
          <div className="col-md-6">
            <div className="integration_content_right">
              <SectionTitle
                title={t("integration.title")}
                subtitle={t("integration.sibtitle")}
              />
              <div className="integration_content">
                <p>{t("integration.description")}</p>
                <div className="integration_features">
                  <span>
                    {" "}
                    <FaCheck /> {t("integration.features1")}
                  </span>
                  <span>
                    {" "}
                    <FaCheck />
                    {t("integration.features2")}
                  </span>
                  <span>
                    {" "}
                    <FaCheck />
                    {t("integration.features3")}
                  </span>
                  <span>
                    {" "}
                    <FaCheck />
                    {t("integration.features4")}
                  </span>
                  <span>
                    {" "}
                    <FaCheck />
                    {t("integration.features5")}
                  </span>
                  <span>
                    {" "}
                    <FaCheck />
                    {t("integration.features6")}
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </IntegrationStyleWrapper>
  );
};

export default Integration;
